import { LocationSearchIllustration } from '@components/illustrations/LocationSearchIllustration';
import { EmptyState } from '@ferreri/prever-component-lib';

export const LoactionSearchEmptyState = () => {
  return (
    <EmptyState
      description="Busque pela localização em que deseja acessar os benefícios."
      illustration={<LocationSearchIllustration />}
    />
  );
};
